import React from "react";
// import Loadable from 'react-loadable';
import WeaBrowser from "./browser";
import WeaDatePicker from "../wea-date-picker";

import "./style/index.less";

// const WeaBrowser = Loadable({
//   loader: () => import('./browser'),
//   loading: () => null,
//   render: (obj: any, props: any) => {
//     if (obj) {
//       let ref = null;
//       let objProps = { ...props };
//       if (props.wrappedComponentRef) {
//         ref = props.wrappedComponentRef;
//       }
//       if (ref) {
//         objProps = { ...props, ref };
//       }
//       return React.createElement(
//         obj && obj.__esModule ? obj.default : obj,
//         objProps,
//       );
//     }
//     return null;
//   },
// });

const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.searchAdFormCallbackKey = getHash();
  }
  focus() {
    this.browser && this.browser.focus && this.browser.focus();
  }
  set(datas) {
    this.browser && this.browser.set && this.browser.set(datas);
  }
  openModal() {
    this.browser && this.browser.openModal && this.browser.openModal();
  }
  closeModal() {
    this.browser && this.browser.closeModal && this.browser.closeModal();
  }
  get() {
    return this.browser && this.browser.get && this.browser.get();
  }
  reload() {
    this.browser && this.browser.reload && this.browser.reload();
  }
  render() {
    const { type } = this.props;
    const _type = Number(type);
    if ([2, 19, 290].indexOf(_type) !== -1) {
      return (
        <WeaDatePicker
          initFunc={browser => (this.browser = browser)}
          {...this.props}
        />
      );
    }
    return (
      <WeaBrowser
        ref={browser => (this.browser = browser)}
        {...this.props}
        searchAdFormCallbackKey={this.searchAdFormCallbackKey}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/index.js